import { createStyles } from '../withStyles';
const styles = (theme) => createStyles({
    root: {
        color: theme.menu.foreground,
        fontSize: theme.fontSizes.sm,
        padding: theme.spacing(2),
    },
});
export default styles;
//# sourceMappingURL=MenuTitle.styles.js.map